import React from 'react';
import { SvgIcon } from '../svg-icon';
import { IconSize } from '../types';
const PlusBadgeIcon = ({ size, ...props }) => {
    let width;
    let height;
    switch (size) {
        case IconSize.S:
            width = 40;
            height = 12;
            break;
        case IconSize.XS:
            width = 30;
            height = 10;
            break;
        default:
            width = 60;
            height = 18;
            break;
    }
    return (React.createElement(SvgIcon, Object.assign({}, props, { width: `${width}px`, height: `${height}px`, viewBox: "0 0 60 18" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2.807H6.364L6.28.821a.429.429 0 00-.358.43l-.53 2.86h5.85c1.816.071 2.732 1.158 2.388 3.189a3.604 3.604 0 01-3.847 3.003H7.967l.63-3.547H5.22a.457.457 0 00-.372.358l-.557 3.26H.902a.43.43 0 00-.357.358l-.53 2.86h3.676l-.63 3.561h3.39a.472.472 0 00.358-.372l.572-3.189h2.545a6.922 6.922 0 007.137-5.963C17.82 3.58 15.49.807 11.199.807zM24.771.807l-.014.014h-3.39a.429.429 0 00-.343.358l-2.86 15.974h9.739a.472.472 0 00.358-.372l.572-3.189h-6.35L24.77.807zM53.345 7.228c-1.473-.486-2.46-.815-2.274-1.916.252-.998.938-1.529 2.23-1.516a6.907 6.907 0 014.077 1.344l2.23-2.574a9.238 9.238 0 00-5.891-2.06c-2.96-.114-5.692 1.216-6.25 4.477-.558 3.26 1.688 4.762 4.162 5.477 1.716.472 2.903 1.001 2.717 2.074-.186 1.073-1.373 1.602-2.717 1.602a6.393 6.393 0 01-4.162-1.73l-2.303 2.645a8.68 8.68 0 006.078 2.446c3.018 0 6.064-.987 6.808-4.548.772-3.904-2.589-5.077-4.705-5.72zM42.032.807a.458.458 0 00-.457.372l-1.888 10.554a2.731 2.731 0 01-2.789 2.374 2.045 2.045 0 01-2.13-2.403L36.712.807h-3.289a.458.458 0 00-.458.372l-1.83 10.225a5.005 5.005 0 005.363 6.05c3.661 0 6.15-1.716 6.836-5.45L45.336.808h-3.303z", fill: "#FF6900" })));
};
PlusBadgeIcon.displayName = 'PlusBadgeIcon';
export default PlusBadgeIcon;
//# sourceMappingURL=PlusBadge.js.map